import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CopyIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1920 805v1243H640v-384H128V0h859l384 384h128l421 421zm-384-37h165l-165-165v165zM640 384h549L933 128H256v1408h384V384zm1152 512h-384V512H768v1408h1024V896z" />
    </svg>
  ),
  displayName: 'CopyIcon',
});

export default CopyIcon;
